import React, { useEffect, useRef, useState } from "react";
import useNotifications from "../../hooks/useNotifications"; // Custom hook for fetching notifications
import "../../style/notification.css";
import { Link, Redirect, Route, useHistory } from "react-router-dom";
import { step_names } from "Components/Coachdashboard/StepNames";
import { stepKeyToPath } from "Components/Baselayout/StaticValues";

const Notification = () => {
  const { notifications, hasUnread, markAsRead } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  const [viewAll, setViewAll] = useState(false);
  const [notif, setNotif] = useState(notifications);
  const dropdownRef=useRef()
  const history = useHistory();
  // Handle clicking the bell icon
  const handleClick = () => {
    setIsOpen(!isOpen);
    !isOpen && markAsRead(); // Remove red dot when clicked
  };

  useEffect(() => {
    viewAll ? setNotif(notifications) : setNotif(notifications.slice(0,5))
  }, [viewAll, notifications])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]); 
  

  return (
    <div className="notification-container" ref={dropdownRef}>
      <div className="notification-icon" onClick={handleClick} style={{ cursor: "pointer", }}>
        <img src="https://django-woken-static.s3.amazonaws.com/static/media/notificationbell.svg" alt="notification" />
        {hasUnread && <span className="red-dot"></span>} 
      </div>

      {isOpen && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h4>Notifications</h4>
            <a href="javascript:(void)" onClick={(e) => {
              e.stopPropagation();
              console.log('sss viewAll', notif)
              notifications.length > 5 && setViewAll(!viewAll)
            }}>{ viewAll ? "View Less" : "View All" }</a>
          </div>
          <div className="notification-list">
            {notif.map((notif) => (
              <div key={notif.id} className="notification-item"
                onClick={() => {
                  // history.push(stepKeyToPath[notif.step])
                }}
              >
                <img src={notif.icon} alt="notify" />
                <div
                  style={{
                    display: "grid",
                    rowGap: "5px"
                  }}
                >
                  <p className="notification-message" dangerouslySetInnerHTML={{ __html: notif.message }} />
                  <p className="notification-time">{notif.time}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Notification;
